import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';


(function () {
  'use strict';

  const logoSliders = document.querySelectorAll('.logo__splide');
  if (logoSliders.length === 0) return;
  new Splide( '.logo__splide .splide' ).mount( { AutoScroll } );

  const splide = new Splide( '.logo__splide .splide', {
    type   : 'loop',
    drag   : 'free',
    focus  : 'center',
    perPage: 3,
    autoScroll: {
      speed: 2,
      pauseOnHover: false,
    },
  } );
  
})();
